import type { Surface } from '../core/hp/types';
import { t } from '../i18n/I18n';

/** The tile sizes the sheet takes, in metres: a centimetre to twenty metres. */
export const TILE_SIZE = { min: .01, max: 20 } as const;

/**
 * A texture laid at a tile size of its own, in metres — the app's TextureScale (ChangeTextureDimension): the tile's
 * width and its height, its length on a floor or a ceiling, each on its own. The tiling of a model's own UVs follows,
 * as it follows the scale slider (`withTextureScalePercent`), and the size it came with stays the slider's 100 %.
 */
export function withTileSize(surface: Surface, size: readonly [number, number]): Surface {
  if (!size.every(value => Number.isFinite(value) && value >= TILE_SIZE.min && value <= TILE_SIZE.max)) throw new Error(t('#TileSizeRange'));
  const original = surface.originalTileMeters ?? surface.tileMeters ?? [1, 1];
  const current = surface.tileMeters ?? original;
  const baseTiling = surface.originalTiling ?? (surface.tiling ? [
    surface.tiling[0] * current[0] / original[0], surface.tiling[1] * current[1] / original[1],
  ] as [number, number] : undefined);
  return { ...surface, originalTileMeters: [original[0], original[1]], tileMeters: [size[0], size[1]],
    ...(baseTiling ? { originalTiling: baseTiling, tiling: [baseTiling[0] * original[0] / size[0], baseTiling[1] * original[1] / size[1]] as [number, number] } : {}) };
}
